import {
  Activity,
  AlertCircle,
  BarChart3,
  Bell,
  Box,
  Building2,
  Calendar,
  CheckCircle,
  ClipboardCheck,
  Clock,
  Database,
  DollarSign,
  FileSearch,
  FileText,
  Home,
  Image,
  Key,
  LayoutDashboard,
  LineChart,
  Mail,
  Megaphone,
  MessageCircle,
  MessageSquare,
  MoreHorizontal,
  Package,
  PieChart,
  Settings,
  Shield,
  ShieldAlert,
  ShieldCheck,
  TestTube,
  TrendingUp,
  Truck,
  User,
  Users,
  Zap,
  MapPin,
} from "lucide-react";
import type { NavConfig } from "@/types/navigation";

export const adminNavConfig: NavConfig = {
  primaryCTA: {
    label: "Broadcast Studio",
    mobileLabel: "Broadcast",
    href: "/admin/notifications/new",
    icon: Megaphone,
  },
  sections: [
    {
      id: "workspace",
      label: "Core Workspace",
      items: [
        { label: "Dashboard", href: "/admin/dashboard", icon: LayoutDashboard },
        { label: "Users", href: "/admin/users", icon: Users },
        { label: "Orders", href: "/admin/orders", icon: Package },
        { label: "RFQs", href: "/admin/rfqs", icon: FileText },
        { label: "Territories & Reps", href: "/admin/territories", icon: MapPin },
        { label: "Messages", href: "/admin/messages", icon: MessageSquare },
        { label: "Support Inbox", href: "/admin/support", icon: MessageCircle },
      ],
    },
    {
      id: "analytics",
      label: "Analytics & Insights",
      icon: BarChart3,
      items: [
        { label: "Analytics Overview", href: "/admin/analytics", icon: BarChart3 },
        { label: "Executive Dashboard", href: "/admin/analytics/executive", icon: LineChart },
        { label: "Financial Dashboard", href: "/admin/analytics/financial", icon: DollarSign },
        { label: "Pipeline Dashboard", href: "/admin/analytics/pipeline", icon: PieChart },
        { label: "Customer Health", href: "/admin/analytics/customers", icon: Activity },
        { label: "Payment Failures", href: "/admin/analytics/payment-failures", icon: AlertCircle },
      ],
    },
    {
      id: "review",
      label: "Review & Compliance",
      icon: ClipboardCheck,
      items: [
        { label: "Review Queue", href: "/admin/review-queue", icon: ClipboardCheck },
        { label: "Vendor Applications", href: "/admin/vendor-applications", icon: Building2 },
        { label: "Compliance", href: "/admin/compliance", icon: ShieldCheck },
      ],
    },
    {
      id: "catalog",
      label: "Catalog & Content",
      icon: Package,
      items: [
        { label: "Products", href: "/admin/products", icon: Package },
        { label: "3D Model Library", href: "/admin/model-library", icon: Box },
        { label: "Product Images", href: "/admin/populate-images", icon: Image },
        { label: "Trending Management", href: "/admin/trending-management", icon: TrendingUp },
      ],
    },
    {
      id: "communication",
      label: "Communication",
      icon: Mail,
      items: [
        { label: "Email Management", href: "/admin/email-management", icon: Mail },
        { label: "Notifications", href: "/admin/notifications", icon: Bell },
      ],
    },
    {
      id: "monitoring",
      label: "Monitoring & Security",
      icon: Shield,
      items: [
        { label: "System Status", href: "/admin/system-status", icon: Activity },
        { label: "System Logs", href: "/admin/system-logs", icon: FileText },
        { label: "Security Dashboard", href: "/admin/security", icon: ShieldAlert },
        { label: "Fraud Detection", href: "/admin/fraud-detection", icon: Shield },
        { label: "Error Logs", href: "/admin/error-logs", icon: AlertCircle },
        { label: "Cron Monitoring", href: "/admin/cron-monitoring", icon: Clock },
      ],
    },
    {
      id: "tools",
      label: "Data & Tools",
      icon: Database,
      items: [
        { label: "Data Management", href: "/admin/data-management", icon: Database },
        { label: "Data Audit", href: "/admin/data-audit", icon: FileSearch },
        { label: "Tracking Lookup", href: "/admin/tracking-lookup", icon: Truck },
        { label: "Navigation Audit", href: "/admin/navigation-audit", icon: Zap },
        { label: "Testing Lab", href: "/admin/testing", icon: TestTube },
      ],
    },
    {
      id: "settings",
      label: "Settings & Account",
      icon: Settings,
      items: [
        { label: "Settings", href: "/admin/settings", icon: Settings },
        { label: "Admin Settings", href: "/admin/admin-settings", icon: Key },
        { label: "Profile", href: "/admin/profile", icon: User },
      ],
    },
  ],
  mobileBottomNav: [
    { label: "Dashboard", href: "/admin/dashboard", icon: Home },
    { label: "Users", href: "/admin/users", icon: Users },
    { label: "Orders", href: "/admin/orders", icon: Package },
    { label: "Support", href: "/admin/support", icon: MessageCircle },
    { label: "More", href: "#more", icon: MoreHorizontal, type: "more" },
  ],
};
